<h2>Stats per Client</h2>

<p>You can optionally filter on certain dates, both start and end date are inclusive.</p>
<mat-form-field>
  <input matInput [matDatepicker]="picker" placeholder="Start Date" [(ngModel)]="fromDate" />
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
<mat-form-field>
  <input matInput [matDatepicker]="picker2" placeholder="End Date" [(ngModel)]="endDate" />
  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
  <mat-datepicker #picker2></mat-datepicker>
</mat-form-field>

<button mat-raised-button (click)="clearDates()">Clear Dates</button>
<button mat-raised-button (click)="currentMonth()">Current Month</button>
<button mat-raised-button (click)="lastMonth()">Last Month</button>

<mat-table [dataSource]="dataSource" matSort>
  <ng-container matColumnDef="name">
    <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef> Client </mat-header-cell>
    <mat-cell mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="clientId">
    <mat-header-cell mat-header-cell *matHeaderCellDef> Id </mat-header-cell>
    <mat-cell mat-cell *matCellDef="let element"> {{ element.clientId }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="conversions">
    <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef> Conversions </mat-header-cell>
    <mat-cell mat-cell *matCellDef="let element"> {{ element.conversions | number : '1.0-0' }} </mat-cell>
  </ng-container>

  <ng-container matColumnDef="percentage">
    <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef> Percentage </mat-header-cell>
    <mat-cell mat-cell *matCellDef="let element"> {{ element.percentage | number : '2.2-2' }} % </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="['name', 'clientId', 'conversions', 'percentage']"></mat-header-row>
  <mat-row *matRowDef="let row; columns: ['name', 'clientId', 'conversions', 'percentage']"></mat-row>
</mat-table>

<div class="total">
  <strong>Total conversions: </strong>
  <span>{{ totalConversions() || 0 | number : '1.0-0' }}</span>
</div>
